import "./App.css";

import React, { useEffect, useContext, useState, useMemo } from "react";
import "@abb/abb-common-ux-react/styles.css";
import { RootProvider } from "./contexts/root-context";
import Dashboard from "./pages/dashboard/dashboard";
import Navbar from "./components/Navbar/navbar";
import { getDefaultTimeStamp, bedasgetDefaultTimeStamp } from "./util";
import ABBLogin from "./pages/login/login";
import CogniENRoutes from "./routes";
import { Amplify } from "aws-amplify";
import { awsConfig } from "./components/Authentication/aws-config";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter } from "react-router-dom/dist";
import { RbacProvider } from "./pages/cognien-pages/user-management/RbacContext";;

function App() {
   const [value, setValue] = React.useState(42);
    const [range, setRange] = React.useState([0, 100]);
    const [decimals, setDecimals] = React.useState(0);
    const [warnings, setWarnings] = React.useState([25, 75]);
    const [alarms, setAlarms] = React.useState([10, 90]);
    const [limitMarkerStyle, setLimitMarkerStyle] = React.useState("parallel");
    const [isnotify, setisnotify] = React.useState("");
    const [mapMarkerErrorMsg, setmapMarkerErrorMsg] = React.useState("");
    const [markerloading, setMarkerLoading] = React.useState("");
    const [username, setusername] = React.useState("");
    const [primaryFilter, setprimaryFilter] = React.useState([]);
    const [opsAreaFilter, setOpsAreaFilter] = React.useState([]);
  
    const [checkedValues, setCheckedValues] = React.useState([]);
    //DR Metrics
    const [relay, setrelayMetrics] = React.useState([]);
    const [drmetrics, setdrmetrics] = React.useState([]);
    const [subIds, setSubIds] = useState([]);
    //No.of records in notification widget
    const [totalDistRowCounts, settotalDistRowCounts] = useState(0);
    const [totalNotiRecords, settotalNotiRecords] = React.useState(0);
    //Notification handling
    const [drwidgetConfig, setdrwidgetConfig] = React.useState([
      { isDialogOpen: false, isDRSucceedNofify: false, currentFile: "" },
    ]);
   
    //  const [authDetails, setauthDetails] = React.useState(JSON.parse(localStorage.getItem("currentUserInfo")) || []);
    const [metricsLoading, setMetricsLoading] = useState(false);
  
  Amplify.configure(awsConfig);
  const [authDetails, setauthDetails] = React.useState([
    { uname: username, password: "", email: "", token: "" },
  ]);

  const [digitalTwinsData, setDigitalTwinsData] = useState();
  const [siteKpis, setSiteKpis] = useState();
  const [powerTrendsData, setPowerTrendsData] = useState();
  const [forecastData, setForecastData] = useState();
  const [energyMixSelectedDuration, setEnergyMixSelectedDuration] =
    useState("day");
  const [powerFlowSelectedOption, setPowerFlowSelectedOption] = useState([
    "Solar Generated Power",
  ]);
  // Trends CO2 Emissions Forecast
  const [
    co2EmissionForecastSelectedDuration,
    setCo2EmissionForecastSelectedDuration,
  ] = useState("Monthly");
  const [selectedDeviceNameOption, setSelectedDeviceNameOption] = useState([
    "HVAC_2N",
  ]);
  const [selectedDeviceMeasureOption, setSelecteDeviceMeasureOption] = useState(
    ["Frequency"]
  );
  // Trends CO2 Emissions
  const [co2EmissionSelectedDuration, setCo2EmissionSelectedDuration] =
    useState("Last 30 days");
  // Trends Energy Mix Forecast
  const [
    energyMixForecastSelectedDuration,
    setEnergyMixForecastSelectedDuration,
  ] = useState("Monthly");
  //Microgid States
  const [isInputSettingClicked, setisInputSettingClicked] = useState(false);
  const [microgridObj,setmicrogridObj]=useState({s3InputUrl:"",dataExist:false,s3OutputUrl:""});
  const [microGridAccuracyData,setMicroGridAccuracyData]=useState();
  const [microGridFilteredDropdownList,setMicroGridFilteredDropdownList]=useState(['load0']);
  //Proofer Tool
  const [currentProoferState, setcurrentProoferState] = useState("welcome");
  //WNT
  const [showConfigureSLDPage, setShowConfigureSLDPage] = useState(false);
  const [uploadedSLD, setUploadedSLD] = useState(null);

  
    const [SpinnerVal, setSpinner] = React.useState(false);
    let defaultTS = getDefaultTimeStamp();
    let input = localStorage.getItem("filterInput")
      ? JSON.parse(localStorage.getItem("filterInput"))
      : defaultTS;
    const [startTS, setstartTS] = React.useState(
      input?.start ? input.start : defaultTS.startDate
    );
    const [endTS, setendTS] = React.useState(
      input?.end ? input.end : defaultTS.endDate
    );
   

    //bedas

    let bedasdefaultTS = bedasgetDefaultTimeStamp();
    let bedasinput = localStorage.getItem("bedasfilterInput")
      ? JSON.parse(localStorage.getItem("bedasfilterInput"))
      : bedasdefaultTS;
    const [bedasstartTS, bedassetstartTS] = React.useState(
      bedasinput?.start ? bedasinput.start : bedasdefaultTS.startDate
    );
    const [bedasendTS, bedassetendTS] = React.useState(
      bedasinput?.end ? bedasinput.end : bedasdefaultTS.endDate
    );
  
    
    const [selectedTimeTitle, setselectedTimeTitle] = React.useState(
      bedasinput?.title ? bedasinput.title : "Last 24 hours"
    );
   
  
  // Add state for left pane open/close
  const [isLeftPaneOpen, setisLeftPaneOpen] = useState("full");
  return (
    <div className="App">
      <div className="main-container">
        <RbacProvider>
        <RootProvider
          value={{
            setSpinner,
            SpinnerVal,
            startTS,
            setstartTS,
            endTS,
            setendTS,
            bedasstartTS,
            bedassetstartTS,
            bedasendTS,
            bedassetendTS,
            isnotify,
            setisnotify,
            authDetails,
            setauthDetails,
            siteKpis,
            setSiteKpis,
            powerTrendsData,
            setPowerTrendsData,
            energyMixSelectedDuration,
            setEnergyMixSelectedDuration,
            powerFlowSelectedOption,
            setPowerFlowSelectedOption,
            forecastData,
            setForecastData,
            co2EmissionForecastSelectedDuration,
            setCo2EmissionForecastSelectedDuration,
            selectedDeviceNameOption,
            setSelectedDeviceNameOption,
            selectedDeviceMeasureOption,
            setSelecteDeviceMeasureOption,
            digitalTwinsData,
            setDigitalTwinsData,
            co2EmissionSelectedDuration,
            setCo2EmissionSelectedDuration,
            energyMixForecastSelectedDuration,
            setEnergyMixForecastSelectedDuration,
            isInputSettingClicked,
            setisInputSettingClicked,
            currentProoferState,
            setcurrentProoferState,
            microgridObj,
            setmicrogridObj,
            microGridAccuracyData,
            setMicroGridAccuracyData,
            microGridFilteredDropdownList,
            setMicroGridFilteredDropdownList,
            showConfigureSLDPage,
            setShowConfigureSLDPage,
            uploadedSLD,
            setUploadedSLD,
            metricsLoading,
            setMetricsLoading,
            drmetrics,
            setdrmetrics,
            relay,
            setrelayMetrics,
            // Add these two for left pane
            isLeftPaneOpen,
            setisLeftPaneOpen,

            setSpinner,
            SpinnerVal,
            mapMarkerErrorMsg,
            setmapMarkerErrorMsg,
            markerloading,
            setMarkerLoading,
            startTS,
            setstartTS,
            endTS,
            setendTS,
            selectedTimeTitle,
            setselectedTimeTitle,
            isnotify,
            setisnotify,
   
            isLeftPaneOpen,
            setisLeftPaneOpen,
            primaryFilter,
            setprimaryFilter,
            opsAreaFilter,
            setOpsAreaFilter,
            checkedValues,
            setCheckedValues,
            drwidgetConfig,
            setdrwidgetConfig,
            totalDistRowCounts,
            settotalDistRowCounts,
            totalNotiRecords,
            settotalNotiRecords,
            relay,
            setrelayMetrics,
            drmetrics,
            setdrmetrics,
            subIds,
            setSubIds,
            metricsLoading,
            setMetricsLoading,
          }}
        >
          <CogniENRoutes />
        </RootProvider>
        </RbacProvider>
      </div>
    </div>
  );
}

export default App;
 